// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   collection,
//   doc,
//   setDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { auth, db } from "../firebase";
// import "./CreateLog.css";

// export default function CreateLog() {
//   const navigate = useNavigate();

//   const [title, setTitle] = useState("");
//   const [note, setNote] = useState("");
//   const [expiryHours, setExpiryHours] = useState(24);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleCreateLog = async () => {
//     try {
//       setError("");
//       setLoading(true);

//       const user = auth.currentUser;
//       if (!user) {
//         throw new Error("You must be logged in");
//       }

//       // 🔹 Calculate expiry (frontend)
//       const expiryAt = new Date(
//         Date.now() + expiryHours * 60 * 60 * 1000
//       );

//       // 🔹 Create log reference
//       const logRef = doc(collection(db, "logs"));

//       // 🔹 Create log document
//       await setDoc(logRef, {
//         owner_id: user.uid,
//         title: title || "Untitled Log",
//         log_type: "MANUAL",
//         status: "PENDING",
//         created_at: serverTimestamp(),
//         expiry_at: expiryAt,
//       });

//       // 🔹 Create first event
//       const eventRef = doc(collection(db, "log_events"));
//       await setDoc(eventRef, {
//         log_id: logRef.id,
//         event_type: "LOG_CREATED",
//         actor: "USER",
//         timestamp: serverTimestamp(),
//         metadata: {
//           note: note || null,
//         },
//       });

//       // ✅ Redirect
//       navigate(`/logs/${logRef.id}`);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || "Failed to create log");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="signup-wrapper">
//       <div className="yellow-circle"></div>

//       <div className="signup-card">
//         <h1>Create Log</h1>
//         <p className="subtitle">
//           This log will be saved permanently.
//         </p>

//         {error && <div className="error">{error}</div>}

//         <div className="input-group">
//           <input
//             placeholder="Title (optional)"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//           />
//         </div>

//         <div className="input-group">
//           <textarea
//             className="note-input"
//             placeholder="Note (optional)"
//             value={note}
//             onChange={(e) => setNote(e.target.value)}
//           />
//         </div>

//         <div className="input-group">
//           <select
//             value={expiryHours}
//             onChange={(e) => setExpiryHours(Number(e.target.value))}
//           >
//             <option value={24}>Expires in 24 hours</option>
//             <option value={48}>Expires in 48 hours</option>
//             <option value={72}>Expires in 72 hours</option>
//             <option value={168}>Expires in 7 days</option>
//           </select>
//         </div>

//         <button
//           className="signup-btn"
//           onClick={handleCreateLog}
//           disabled={loading}
//         >
//           {loading ? "Creating..." : "Create Log"}
//         </button>
//       </div>
//     </div>
//   );
// }











































import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import "./CreateLog.css";

export default function CreateLog() {
  const navigate = useNavigate();

  // 🔹 Form state
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  const [expiryHours, setExpiryHours] = useState(24);

  // 🔹 UI state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 🔹 Firebase callable
  const createLogFn = httpsCallable(functions, "createLog");

  // =====================================================
  // CREATE LOG HANDLER
  // =====================================================
  const handleCreateLog = async () => {
    setError("");

    if (loading) return;

    try {
      setLoading(true);

      const res = await createLogFn({
        title,
        note,
        expiryHours,
      });

      const { logId } = res.data;

      if (!logId) {
        throw new Error("Log creation failed");
      }

      // ✅ Redirect to Log Detail page
      navigate(`/logs/${logId}`);
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to create log");
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // UI
  // =====================================================
  return (
    <div className="signup-wrapper">
      <div className="yellow-circle"></div>

      <div className="signup-card">
        <h1>Create New Log</h1>

        <p className="subtitle">
          This log will be immutable and time-stamped by the server.
        </p>

        {error && <p className="error-text">{error}</p>}

        {/* 🔹 Title */}
        <div className="input-group">
          <input
            type="text"
            placeholder="Title (optional)"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* 🔹 Note */}
        <div className="input-group">
          <textarea
            placeholder="Note (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>

        {/* 🔹 Expiry */}
        <div className="input-group">
          <label>Expiry Time</label>
          <select
            value={expiryHours}
            onChange={(e) => setExpiryHours(Number(e.target.value))}
          >
            <option value={1}>1 hour</option>
            <option value={6}>6 hours</option>
            <option value={12}>12 hours</option>
            <option value={24}>24 hours (default)</option>
            <option value={48}>48 hours</option>
            <option value={72}>72 hours</option>
          </select>
        </div>

        {/* 🔹 Submit */}
        <button
          className="signup-btn"
          onClick={handleCreateLog}
          disabled={loading}
        >
          {loading ? "Creating…" : "Create Log"}
        </button>
      </div>
    </div>
  );
}
